export const INVESTMENT_TYPE: {[key:string] : any } = {
    PAYMENT : {name: 'Pago', color:'green'},
    SALE : {name: 'Venta', color:'blue'},
    BUY : {name: 'Compra', color:'orange'},
    LIQUIDATION : {name: 'Liquidación', color:'grey'},
    CASH_ADJUSTMENT : {name: 'Ajuste de Saldo', color:'purple'}
  }